/**
 * Route auth helpers.
 * Guest routes = no auth required; protected = requires auth and we fetch /me there.
 */

const GUEST_PATHS = ['/', '/login', '/signup', '/recover-userid'] as const;

/** True if pathname is a guest route (login, signup, etc.). /me is not fetched on these. */
export function isGuestRoute(pathname: string): boolean {
  if (GUEST_PATHS.includes(pathname as typeof GUEST_PATHS[number])) return true;
  if (pathname.startsWith('/signup/')) return true;
  return false;
}

/** True if pathname is a protected route – we fetch /me when user is authenticated. */
export function isProtectedRoute(pathname: string): boolean {
  return !isGuestRoute(pathname);
}
